import { useTranslation as e } from "../../i18n/hooks.js";
import { Actions as t } from "../primitive/actions.js";
import { Calendar as n, DoubleCalendar as r } from "../primitive/calendar.js";
import { DateField as i } from "../primitive/date-field.js";
import { DateRangeSummary as a } from "../primitive/date-range-summary.js";
import { FilterPresets as o } from "../primitive/filter-presets.js";
import { Popup as s } from "../primitive/popup.js";
import { formatDate as c } from "../utils/date-utils.js";
import { useDateFnsLocale as l } from "../utils/use-date-fns-locale.js";
import { useDateRange as u } from "./use-date-range.js";
import { useState as d } from "react";
import { Fragment as f, jsx as p, jsxs as m } from "react/jsx-runtime";
import { useMediaQuery as h } from "@systemeio/util";
import { enUS as g } from "date-fns/locale/en-US";
//#region src/date-picker/date-range-picker/date-range-picker.tsx
function _({ date: _, minDate: v, maxDate: y, maxInterval: b, timezone: x, customFilters: S, disabled: C, intlLocale: w, label: T, placeholder: E, showFilterPresets: D = !0, clearable: O, required: ee, size: te, error: ne, description: re, wrapperButtonInputClassName: ie, labelClassName: k, getDefaultDate: A, onChange: j }) {
	let { t: M } = e(), { isMobile: N } = h(), [P, F] = d(!1), [I, L] = d(g);
	l(w, L);
	let { activeFilter: R, appliedDateSince: z, appliedDateTill: B, filterPresets: V, handleApply: H, handleChange: U, handleClear: W, resetDraftRange: G, resolvedMinDate: K, selectedDateSince: q, selectedDateTill: J, setActiveFilter: Y } = u({
		customFilters: S,
		date: _,
		getDefaultDate: A,
		intlLocale: w,
		maxInterval: b,
		minDate: v,
		onChange: j,
		timezone: x
	}), X = (e) => e ? c(e, { timeZone: x }) : "-", Z = () => {
		F(!1);
	}, Q = () => {
		H(), Z();
	}, $ = () => {
		W(), Z();
	}, ae = (e) => {
		F(e), e || G();
	}, oe = z && B ? `${new Intl.DateTimeFormat(w, {
		day: "2-digit",
		month: N ? "2-digit" : "long",
		year: N ? "2-digit" : "numeric"
	}).format(z)} - ${new Intl.DateTimeFormat(w, {
		day: "2-digit",
		month: N ? "2-digit" : "long",
		year: N ? "2-digit" : "numeric"
	}).format(B)}` : void 0;
	return /* @__PURE__ */ p(s, {
		title: M("public_pages_purchase.date_picker.date_filter_title"),
		disabled: C,
		open: P,
		onClose: Z,
		onOpenChange: ae,
		trigger: /* @__PURE__ */ p(i, {
			label: T,
			required: ee,
			size: te,
			error: ne,
			description: re,
			value: oe,
			placeholder: E ?? M("public_pages_purchase.date_picker.title_dates"),
			disabled: C,
			clearable: O,
			focus: P,
			labelClassName: k,
			className: ie,
			onClear: $
		}),
		triggerRender: /* @__PURE__ */ p("div", {
			"aria-label": T ? void 0 : E ?? M("public_pages_purchase.date_picker.title_dates"),
			className: "w-full text-left",
			role: "button",
			tabIndex: 0
		}),
		children: N ? /* @__PURE__ */ m(f, { children: [
			D && /* @__PURE__ */ p(o, {
				className: "px-4 py-3",
				disabled: C || !x,
				onChange: Y,
				presets: V,
				value: R
			}),
			/* @__PURE__ */ p(n, {
				dateFormat: "MMMM d, yyyy",
				endDate: J,
				intlLocale: w,
				locale: I,
				maxDate: y,
				minDate: K,
				onChange: U,
				selected: q,
				selectsRange: !0,
				startDate: q
			}),
			/* @__PURE__ */ p(a, {
				className: "mx-4 my-3 justify-between",
				fromValue: X(q),
				toValue: X(J)
			}),
			/* @__PURE__ */ p(t, {
				className: "m-4 gap-3",
				applyDisabled: !q || !J || C,
				clearDisabled: C,
				onApply: Q,
				onClear: $
			})
		] }) : /* @__PURE__ */ m("div", {
			className: "flex flex-row",
			children: [/* @__PURE__ */ m("div", {
				className: "flex flex-col",
				children: [
					/* @__PURE__ */ p(r, {
						dateFormat: "MMMM d, yyyy",
						endDate: J,
						intlLocale: w,
						locale: I,
						maxDate: y,
						minDate: K,
						onChange: U,
						selected: q,
						selectsRange: !0,
						startDate: q
					}),
					/* @__PURE__ */ p(a, {
						className: "mx-4 mb-5 grid grid-cols-2 gap-0 [&>div:last-child]:ml-2",
						fromValue: X(q),
						toValue: X(J)
					}),
					!D && /* @__PURE__ */ p(t, {
						className: "mr-4 mb-4 ml-auto",
						applyDisabled: !q || !J || C,
						clearDisabled: C,
						onApply: Q,
						onClear: $
					})
				]
			}), D && /* @__PURE__ */ m("div", {
				className: "border-border-200 flex flex-col justify-between gap-2 border-l p-4",
				children: [/* @__PURE__ */ p(o, {
					disabled: C || !x,
					onChange: Y,
					presets: V,
					value: R
				}), /* @__PURE__ */ p(t, {
					className: "flex-col",
					applyDisabled: !q || !J || C,
					clearDisabled: C,
					onApply: Q,
					onClear: $
				})]
			})]
		})
	});
}
//#endregion
export { _ as DateRangePicker };
